import { ControlInfo } from 'ia-react-core/~/interfaces/ControlInfo';
import React from 'react';

export interface ControlGroupContextProps {
  isControlGroup?: boolean;
  controls?: ControlInfo[];
  registerControlGroup?: (controlInfo: ControlInfo) => void;
  unregisterControlGroup?: (controlId: number) => void;
}

const ControlGroupContext = React.createContext<ControlGroupContextProps>({});

export default ControlGroupContext;
